export const ReviewIcon = ({ size = 16, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M1.33334 8.33333C1.33334 8.33333 3.33334 3.33333 8.00001 3.33333C12.6667 3.33333 14.6667 8.33333 14.6667 8.33333C14.6667 8.33333 12.6667 13.3333 8.00001 13.3333C3.33334 13.3333 1.33334 8.33333 1.33334 8.33333Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 10C8.92047 10 9.66667 9.25381 9.66667 8.33333C9.66667 7.41286 8.92047 6.66667 8 6.66667C7.07953 6.66667 6.33333 7.41286 6.33333 8.33333C6.33333 9.25381 7.07953 10 8 10Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
